import React from 'react';
import styled from 'styled-components';
import { withLocalePrefix } from 'shared/utils/translation';
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'shared/DEPRECATED/components/form/layout'. 'app/webpack/javascripts/shared/DEPRECATED/components/form/layout.js' implicitly has an 'any' type.
import { FormField } from 'shared/DEPRECATED/components/form/layout';
import { MultipleRulesContext } from '../../multiple_rules/context';
import { DataCollectionRulesContext } from '../context';
// @ts-expect-error - TS7016 - Could not find a declaration file for module '../../shared/header'. 'app/webpack/javascripts/gdpr/components/shared/header.js' implicitly has an 'any' type.
import { Header } from '../../shared/header';
import Errors from '../../shared/errors';
import OfficesSelector from '../../shared/offices_selector';
import type { DataCollectionRuleInterface } from '../data_collection_rule';

const t = withLocalePrefix('gdpr.data_collection_rules.view.table');

type Props = {
  rule: DataCollectionRuleInterface;
  setRule: any;
};

const OfficesContainerWrapper = styled.div`
  width: 100%;

  /**
   * The first container is going to remove the header row which helps
   * keep consistent spacing. Make sure a minimum width is set
   * for the first row to prevent shuffling.
   */
  &:first-of-type {
    min-width: 317px;
  }
`;

const hasError = (errors: Array<string>) => errors && errors.length;

export default function Offices({ rule, setRule }: Props) {
  const { offices } = React.useContext(MultipleRulesContext);
  const { errors, meta, onFieldChange } = React.useContext(
    DataCollectionRulesContext
  );

  return (
    <OfficesContainerWrapper>
      <FormField
        error={<Errors errors={errors.data_collection_rule_offices} />}
      >
        <Header>{t('header.offices')}</Header>
        <OfficesSelector
          allOfficesPath={meta.all_offices_path}
          error={!!hasError(errors.data_collection_rule_offices)}
          offices={offices}
          rule={rule}
          onChangeSelectedOffices={(selectedOfficesIds: Array<number>) => {
            onFieldChange('data_collection_rule_offices');
            setRule({
              ...rule,
              office_ids: selectedOfficesIds,
            });
          }}
          onToggleAllOffices={(all_offices: boolean) =>
            setRule({ ...rule, all_offices })
          }
        />
      </FormField>
    </OfficesContainerWrapper>
  );
}
